module.exports = __webpack_public_path__ + "media/images/snack_logo-2219f2628041f0608e57f99227b56b4a.svg";